import { render, staticRenderFns } from "./RegistrationErrorModule.vue?vue&type=template&id=16e481a6&scoped=true&"
import script from "./RegistrationErrorModule.vue?vue&type=script&lang=js&"
export * from "./RegistrationErrorModule.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationErrorModule.vue?vue&type=style&index=0&id=16e481a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e481a6",
  null
  
)

export default component.exports